import React from 'react';
/**
 * Formats a number as a currency string
 * @param amount - The amount to format
 * @param currencyCode - The currency code (default: USD)
 * @param locale - The locale code (default: en-AU)
 * @returns Formatted currency string
 */
export const formatCurrency = (amount: number, currencyCode = 'USD', locale = 'en-AU'): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};
/**
 * Formats a number as a currency amount without the currency code
 * @param amount - The amount to format
 * @param locale - The locale code (default: en-AU)
 * @returns Formatted number string with thousand separators and 2 decimal places
 */
export const formatAmount = (amount: number, locale = 'en-AU'): string => {
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};
/**
 * Get available locales for the application
 * @returns Array of locale objects with code and name
 */
export const getAvailableLocales = () => [{
  code: 'en-US',
  name: 'English (United States)'
}, {
  code: 'en-GB',
  name: 'English (United Kingdom)'
}, {
  code: 'en-AU',
  name: 'English (Australia)'
}, {
  code: 'fr-FR',
  name: 'French (France)'
}, {
  code: 'de-DE',
  name: 'German (Germany)'
}, {
  code: 'es-ES',
  name: 'Spanish (Spain)'
}, {
  code: 'it-IT',
  name: 'Italian (Italy)'
}, {
  code: 'ja-JP',
  name: 'Japanese (Japan)'
}, {
  code: 'zh-CN',
  name: 'Chinese (China)'
}, {
  code: 'pt-BR',
  name: 'Portuguese (Brazil)'
}, {
  code: 'ar-SA',
  name: 'Arabic (Saudi Arabia)'
}, {
  code: 'hi-IN',
  name: 'Hindi (India)'
}, {
  code: 'ru-RU',
  name: 'Russian (Russia)'
}];